import ActionType from './action-type'
import * as Actions from './actions'
import {type WasData} from './state'

export function requestWasAction(): Actions.RequestWasAction {
    return {
        type: ActionType.REQUEST_WAS,
    }
}

/**
 * CDS-6008. Clears the loading flag without touching the score, so a failed
 * fetch stops the widget spinning and leaves whatever was last received on
 * screen.
 */
export function wasRequestFailedAction(): Actions.WasRequestFailedAction {
    return {
        type: ActionType.WAS_REQUEST_FAILED,
    }
}

export function receiveWasAction(wasData: WasData): Actions.ReceiveWasAction {
    return {
        type: ActionType.RECEIVE_WAS,
        payload: wasData,
    }
}
